/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { shape, string } from 'prop-types';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import brandtheme from '../../../../components/AppShell/brandtheme';
import { getCurrentBrandId } from '../../state/ducks/Common/Common-Selectors';
import { getPassportPageUrl, getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import listItem from './LeftMenuListItem';
import mbpUtil from 'mbp-api-util';

let appRouterPrefix = '';
const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

if (REACT_APP_INJECTABLE === 'false') {
    appRouterPrefix = '/z';
}

const styles = ({ palette, breakpoints }) => ({
    leftMenus: {
        textDecoration: 'none',
        listStyle: 'none',
        lineHeight: 1.5,
        minWidth: 160,
        borderRight: `1px solid ${palette.grey7}`,
        boxShadow: '2px -3px 4px rgb(47 47 47 / 15%)',
        '& > div': {
            height: '62px',
        },
    },
    listItem: {
        paddingLeft: '12px',
        width: '109px',
        fontSize: '16px !important',
        fontWeight: 400,
        [breakpoints.down(1100)]: {
            fontSize: '13px !important',
        },
    },
    trackOrder: {
        marginTop: 'inherit',
    },
    selectedUrl: {
        backgroundColor: palette.bgContrastPrimaryColor || '#EBEBEB',
    },
    listWrapper: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '20px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: palette.bgContrastPrimaryColor || '#EBEBEB',
        },
    },
    accountHolderName: {
        textAlign: 'center',
        fontSize: '20px !important',
        paddingTop: '30px',
        height: '80px !important',
        textTransform: 'capitalize',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        '& > div': {
            fontSize: '20px !important',
        },
        '& > div:first-child': {
            display: 'flex',
            alignItems: 'center',
            marginRight: '5px',
            '& > div': {
                maxWidth: '190px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'inline-block',
                width: '100%',
                fontSize: '20px !important',
            },
            '& > span': {
                fontSize: '20px !important',
                textTransform: 'lowercase'
            }
        }
    },
});

const AccountLeftMenu = ({ classes, profileAndPassportInfo }) => {
    const brandId = useSelector((state) => getCurrentBrandId(state));
    const passportUrl = useSelector((state) => getPassportPageUrl(state));
    const featureFlags = useSelector((state) => getFeatureFlags(state));

    const customClass = 'trackOrder';
    const dispatch = useDispatch();
    const history = useHistory();

    const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '/';
    const brandIconColor = brandtheme[brandId]?.palette?.colorPrimary;
    const listItemData = listItem(brandIconColor, true);

    const handleListItemClicked = (url, currentUrl, regEx, userRole, type = '') => {
        if (url.includes('/account/passport')) {
            dispatch(
                track({
                    eventCategory: 'Account Navigation',
                    eventAction: 'Click',
                    eventLabel: 'passport',
                }),
            );
        }
        if (currentUrl !== url && !(regEx?.test(currentUrl))) {
            if (userRole && (!profileAndPassportInfo?.passportStartDate || !profileAndPassportInfo?.passportEndDate || !profileAndPassportInfo?.passportFlag)) {
                return history.push(passportUrl);
            }
            if (type === 'external' || type === 'external-sign-out'){
                if (type === 'external-sign-out') {
                    window?.localStorage?.removeItem?.('userInfo');
                    Object.keys(window?.sessionStorage || {}).forEach(item => {
                        if ((item || '').includes('persist:')) {
                            console.log('Clearing persist storage');
                            window.sessionStorage.removeItem(item)
                        }
                    })
                }
                window.location.href = `${appRouterPrefix}${url}`
            } else {
                history.push(`${appRouterPrefix}${url}`);
            }
        }
    };

    return (
        <>
            <Grid className={`${classes.leftMenus} ${classes[customClass]} padding-left`} item xs={2}>
                <>
                    <div className={classes.accountHolderName}>
                        <div><div>{profileAndPassportInfo?.firstName}</div>&apos;<span>s</span></div> <div>Account</div>
                    </div>
                    {listItemData.map((list) => {
                        const isLinkDisabled = (featureFlags?.['app-standalone-account-hide-links'] || []).includes?.(list?.url);
                        if ((list.flag && featureFlags[list.flag] && featureFlags[list.flag] === 'N') || isLinkDisabled) {
                            return <></>;
                        }

                        return (
                            <div
                                key={list.label}
                                role="presentation"
                                className={
                                    currentUrl.includes(list.url) || (list.regEx?.test(currentUrl))
                                        ? `${classes.listWrapper} ${classes.selectedUrl} border-bottom`
                                        : `${classes.listWrapper} border-bottom`
                                }
                                onClick={() => handleListItemClicked(list.url, currentUrl, list.regEx, list.userRole, list?.type)}
                            >
                                <span>{list.icon}</span>
                                <span key={list.id} className={classes.listItem}>
                                    {' '}
                                    {list.label}
                                </span>
                            </div>
                        );
                    })}
                </>
            </Grid>
        </>
    );
};

AccountLeftMenu.propTypes = {
    classes: shape({}).isRequired,
    profileAndPassportInfo: shape({
        firstName: string,
        passportStartDate: string,
        passportEndDate: string,
        passportFlag: string,
    }),
};
export default withStyles(styles)(AccountLeftMenu);
